export const CustomerSubNavCreateTestId = "customer-subnav-create";
export const CustomerSubNavCreateBulkTestId = "customer-subnav-create-bulk";
export const CustomerSubNavMoreTestId = "customer-subnav-more";

export const RequestMoneyCreateButtonId = "request-money-create-button";
export const RequestMoneyCustomerSelectId = "request-money-customer-select";
export const RequestMoneyCustomerDropdownId = "request-money-customer-select-dropdown";
export const RequestMoneyCustomerModalId = "request-money-customer-modal";
export const RequestMoneyAmountId = "request-money-amount";
export const RequestMoneyDescriptionId = "request-money-description";
export const RequestMoneySubNavSubmitId = "request-money-subNav-submit";
